import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { computed } from 'mobx'
import { DateTime } from 'luxon'
import {
  type FirestoreSectionAssignmentConversationItemPromptTest,
  empty,
} from '../firestore/SectionAssignmentConversationItemPromptTest/schema'

export class SectionAssignmentConversationItemPromptTest extends ObservableModelWithDecorators<FirestoreSectionAssignmentConversationItemPromptTest> {
  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSectionAssignmentConversationItemPromptTest>
  ) {
    super(repository, doc)
  }

  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  @computed
  get messageText(): string {
    return this.data.userContent || ''
  }

  @computed
  get createdAtDateTime() {
    return DateTime.fromJSDate(this.data.createdAt)
  }
}
